import { render } from "./HeroiconsOutlineVolumeOff.vue?vue&type=template&id=59daa9be"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVolumeOff.vue"]])

export default __exports__